export class FaturamentoCumprimentoPpb {

  id: number;
  possuiMeta: boolean;
  pontuacaoAtingida: number;
  pontuacaoMinima: number;
}
